import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="fade-in"
// Handles fade-in animation for containers on page load
export default class extends Controller {
  static values = {
    delay: { type: Number, default: 200 },
    speed: { type: String, default: "fast" },
    selector: { type: String, default: ".container" }
  }

  connect() {
    this.animate()
  }

  animate() {
    const elements = this.element.querySelectorAll(this.selectorValue)

    if (elements.length === 0) {
      return
    }

    // Hide elements initially
    elements.forEach(el => {
      if (window.jQuery) {
        window.jQuery(el).hide()
      } else {
        el.style.display = 'none'
      }
    })

    // Delay then fade in
    setTimeout(() => {
      elements.forEach(el => {
        if (window.jQuery) {
          window.jQuery(el).fadeIn(this.speedValue)
        } else {
          // Fallback to CSS animation if jQuery not available
          el.style.display = ''
          el.style.opacity = '0'
          el.style.transition = `opacity ${this.speedValue === 'fast' ? '0.2s' : '0.4s'}`
          requestAnimationFrame(() => {
            el.style.opacity = '1'
          })
        }
      })
    }, this.delayValue)
  }
}
